<template>
  <span class="text-end">{{ formattedTime }}</span>
</template>
  
<script>
import Typography from "./common/Typography.vue"
import { DateTime } from "luxon"

export default {
  components: {
    Typography,
  },
  props: {
    targetDate: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      timeLeft: null,
    }
  },
  computed: {
    formattedTime() {
      if (!this.timeLeft) return "0d 0h 0min"
      const { days, hours, minutes, seconds } = this.timeLeft
      let result = ''
      if (days > 0) {
        result += `${days}d `
      }
      if (hours > 0) {
        result += `${hours}h `
      }
      if (minutes > 0) {
        result += `${minutes}min `
      }
      if (seconds > 0) {
        result += `${seconds}s `
      }
      return result
    },
  },
  methods: {
    calculateTimeLeft() {
      const now = DateTime.utc();
      const target = DateTime.fromISO(this.targetDate, { zone: "utc" });
      const diff = target.diff(now, ["days", "hours", "minutes", "seconds"]);

      if (diff <= 0) {
        return null;
      }

      return {
        days: Math.floor(diff.days),
        hours: Math.floor(diff.hours),
        minutes: Math.floor(diff.minutes),
        seconds: Math.floor(diff.seconds),
      };
    },
    updateTimeLeft() {
      this.timeLeft = this.calculateTimeLeft()

      if (!this.timeLeft) {
        this.onTimerEnd()
        clearInterval(this.interval)
      }
    },
    onTimerEnd() {
      this.$emit('timer-end')
      console.log("Timer has ended")
    },
  },
  mounted() {
    this.updateTimeLeft()
    this.interval = setInterval(this.updateTimeLeft, 1000)
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
}
</script>
  
<style scoped>
</style>
